<template>
  <div>
    <!-- {{this.box}} -->
    <!-- <div v-if="isAdd">
      <v-sheet
        >Add template
        <v-card> Card </v-card>
      </v-sheet>
    </div>
    <div v-if="isEdit">
      <v-sheet>Edit template</v-sheet>
    </div> -->
    <v-card>
      <v-card-title>
        <div v-if="isTemplateClose">
          Box close templates
          <v-alert type="warning" dense
            >Box is open - only possible to work with close templates!</v-alert
          >
        </div>
        <div v-else>Box open templates</div>

        <v-spacer></v-spacer>
        <v-btn rounded small color="primary" @click.stop="addTemplate()">
          <v-icon small>fa-plus</v-icon>
        </v-btn>
      </v-card-title>
      <v-text-field
        v-model="boxname"
        :value="boxname"
        solo
        dense
        :prepend-inner-icon="prependIcon"
        readonly
      ></v-text-field>
      <v-data-table
        :headers="headers"
        :items="boxTemplates"
        :search="search"
        dense
        :loading="loading"
        loading-text="Loading... Please wait"
        hide-default-footer
      >
        <template v-slot:item.IsAdmin="{ item }">
          <v-btn
            color="green"
            dark
            rounded
            x-small
            min-width="100"
            :class="`d-flex justify-space-around mb-4`"
            @click="editTemplate(item)"
            :outlined="item.Outlined"
          >
            <v-icon x-small>fa-edit</v-icon>
          </v-btn>
        </template>
        <template v-slot:item.IsDelete="{ item }">
          <v-btn
            color="red"
            dark
            rounded
            x-small
            min-width="100"
            :class="`d-flex justify-space-around mb-4`"
            @click="deleteYesNo(item)"
            :outlined="item.Outlined"
            :disabled="boxTemplates.length < 2"
          >
            <v-icon x-small>fa-trash-alt</v-icon>
          </v-btn>
        </template>
      </v-data-table>
      <ul v-if="errors && errors.length">
        <li v-for="error of errors" :key="error.id" style="color: Red">
          {{ error.message }}
        </li>
      </ul>
    </v-card>
    <div>.</div>
    <v-btn rounded small color="primary" @click="getboxTemplates(boxid)"
      >Refresh</v-btn
    >
    <!-- <v-btn rounded small color="primary" @click="showUserSearch = !showUserSearch">ADD USER/ROLE</v-btn> -->
    <v-alert type="success" :value="isAlertVisible">
      {{ statusResultMsg }}
      <v-btn small color="primary" @click="getboxTemplates(boxid)"
        >Refresh</v-btn
      >
    </v-alert>
    <v-alert type="error" :value="isWarningAlertVisible">{{
      statusResultMsg
    }}</v-alert>

    <div>
      <!-- YES NO DIALOG       -->
      <v-row justify="center">
        <v-dialog v-model="deleteDialog" persistent max-width="290">
          <!-- <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="primary"
          dark
          v-bind="attrs"
          v-on="on"
        >
          Open Delete Dialog
        </v-btn>
      </template> -->
          <v-card>
            <v-card-title class="text-h5"> Are you sure? </v-card-title>
            <!-- <v-card-text></v-card-text> -->
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="primary"
                rounded
                @click="deleteBoxTemplate(selectedItem)"
              >
                Yes - Delete!
              </v-btn>
              <v-btn color="green darken-1" text @click="deleteDialog = false">
                No - Cancel!
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </div>
    <div>
      <!-- NEW DIALOG       -->
      <v-row justify="center">
        <v-dialog v-model="newDialog" persistent max-width="400">
          <!-- <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="primary"
          dark
          v-bind="attrs"
          v-on="on"
        >
          Open Delete Dialog
        </v-btn>
      </template> -->
          <v-form>
            <v-card>
              <v-card-title class="text-h5">
                New template<v-spacer></v-spacer>
                <v-checkbox
                  v-model="isTemplateOpen"
                  label="Open"
                  color="success"
                  :value="isTemplateOpen"
                  hide-details
                  disabled
                  dense
                ></v-checkbox>
                <v-spacer></v-spacer>
                <v-checkbox
                  v-model="isTemplateClose"
                  label="Close"
                  color="success"
                  :value="isTemplateClose"
                  hide-details
                  disabled
                  dense
                ></v-checkbox
              ></v-card-title>
              <v-row justify="center">
                <v-col cols="12" sm="6">
                  <v-text-field
                    :value="templateName"
                    v-model="templateName"
                    label="Name"
                    hint="Example: A,B 7000"
                    max-length="20"
                    counter
                    outlined
                    :rules="shortNameRules"
                  ></v-text-field>
                  <v-textarea
                    :value="templateComment"
                    v-model="templateComment"
                    label="Description"
                    hint="Example: Hvittingfoss A and B Opened to 7k (2133moh)"
                    max-length="50"
                    counter
                    outlined
                    :rules="descriptionRules"
                  ></v-textarea>
                </v-col>
              </v-row>
              <!-- <v-card-text></v-card-text> -->
              <v-card-actions class="justify-center">
                <v-btn
                  color="primary"
                  rounded
                  @click="newBoxTemplate()"
                  :disabled="
                    templateName.length == 0 || templateComment.length == 0
                  "
                >
                  Save
                </v-btn>
                <v-btn color="green darken-1" text @click="newDialog = false">
                  Cancel
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-form>
        </v-dialog>
      </v-row>
    </div>

    <div>
      <!-- EDIT DIALOG       -->
      <v-row justify="center">
        <v-dialog v-model="editDialog" persistent max-width="400">
          <!-- <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="primary"
          dark
          v-bind="attrs"
          v-on="on"
        >
          Open Delete Dialog
        </v-btn>
      </template> -->
          <v-form>
            <v-card>
              <v-card-title class="text-h5">
                Edit template<v-spacer></v-spacer>
                <v-checkbox
                  v-model="isTemplateOpen"
                  label="Open"
                  color="success"
                  :value="isTemplateOpen"
                  hide-details
                  disabled
                  dense
                ></v-checkbox>
                <v-spacer></v-spacer>
                <v-checkbox
                  v-model="isTemplateClose"
                  label="Close"
                  color="success"
                  :value="isTemplateClose"
                  hide-details
                  disabled
                  dense
                ></v-checkbox
              ></v-card-title>
              <v-row justify="center">
                <v-col cols="12" sm="6">
                  <v-text-field
                    :value="templateName"
                    v-model="templateName"
                    label="Name"
                    hint="Example: A,B 7000"
                    max-length="20"
                    counter
                    outlined
                    :rules="shortNameRules"
                  ></v-text-field>
                  <v-textarea
                    :value="templateComment"
                    v-model="templateComment"
                    label="Description"
                    hint="Example: Hvittingfoss A and B Opened to 7k (2133moh)"
                    max-length="155"
                    counter
                    outlined
                    :rules="descriptionRules"
                  ></v-textarea>
                </v-col>
              </v-row>
              <!-- <v-card-text></v-card-text> -->
              <v-card-actions class="justify-center">
                <v-btn
                  color="primary"
                  rounded
                  @click="setBoxTemplate()"
                  :disabled="
                    templateName.length == 0 || templateComment.length == 0
                  "
                >
                  Update
                </v-btn>
                <v-btn color="green darken-1" text @click="editDialog = false">
                  Cancel
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-form>
        </v-dialog>
      </v-row>
    </div>
  </div>
</template>
  
  <script>
import axios from "axios";

export default {
  name: "BoxTemplates",
  props: {
    box: [],
    regId: Number,
    ac: String,
  },
  data() {
    return {
      search: "",
      loading: true,
      prependIcon: null,

      headers: [
        { text: "id", value: "EventCommentTemplateId" },
        { text: "Name", value: "Name" },

        { text: "Description", value: "CommentTemplate" },

        { text: "Edit", value: "IsAdmin" },
        { text: "Delete", value: "IsDelete" },
      ],
      boxTemplates: [],
      errors: [],
      cancellink: { to: "/events" },
      isValid: true,
      statusResult: Number,
      statusResultMsg: String,
      isAlertVisible: false,
      isWarningAlertVisible: false,
      showUserSearch: false,
      addregId: Number,
      addUserEnabled: false,
      radios: 3,
      boxid: Number,
      boxname: String,
      templateName: String,
      templateComment: String,
      isTemplateClose: false,
      isTemplateOpen: false,
      //   isAdd: false,
      //   isEdit: false,
      deleteDialog: false,
      isDelete: false,
      selectedItem: [],
      newDialog: false,
      editDialog: false,
      shortNameRules: [(v) => v.length <= 21 || "Max 20 characters"],
      descriptionRules: [(v) => v.length <= 155 || "Max 155 characters"],
    };
  },

  created() {
    // let hostName = window.location.hostname;
    // if (hostName == "localhost") {
    //   this.baseUrl = "http://localhost:3000/dbapi/";
    // } else {
    //   this.baseUrl = "https://pgapi.azurewebsites.net/dbapi/";
    // }
    this.baseUrl = "https://pgapi.azurewebsites.net/dbapi/";
    // this.baseUrl = "http://localhost:3000/dbapi/";
    //  console.log("host",hostName);
    this.continueEnabled1 = false;
    this.continueEnabled2 = false;
    this.boxid = this.box.EventId;
    this.boxname = this.box.Event;
    this.getboxTemplates(this.boxid);
    this.templateName = "";
    this.templateComment = "";
  },
  methods: {
    showAlert(a) {
      alert("Alert! \n" + a);
    },
    deleteYesNo(item) {
      this.deleteDialog = true;
      this.selectedItem = item;
      //   console.log("inDeleteYesNo - item", this.selectedItem);
    },
    deleteBoxTemplate(item) {
      //   console.log(item);
      this.deleteDialog = false;
      var eventCommentTemplateId = item.EventCommentTemplateId;
      var regId = this.regId;
      var ac = this.ac;
      var eventId = this.box.EventId;
      var toSubmit = JSON.stringify({
        eventCommentTemplateId,
        eventId,
        regId,
        ac,
      });
      const uri = this.baseUrl + "deleteboxtemplate";
      //   console.log(uri);
      //   console.log(toSubmit);
      this.isAlertVisible = false;
      this.isWarningAlertVisible = false;
      this.sendpost(uri, toSubmit, 1);
      //   this.getboxTemplates(this.selectedEvent);
    },

    setBoxTemplate() {
      //   console.log(opener);
      this.editDialog = false;
      var eventCommentTemplateId = this.selectedItem.EventCommentTemplateId;
      var regId = this.regId;
      var ac = this.ac;
      var eventId = this.box.EventId;
      var name = this.templateName;
      var comment = this.templateComment;
      var isClose = this.selectedItem.IsCloseText;
      var sortBy = this.selectedItem.SortBy;
      var toSubmit = JSON.stringify({
        eventCommentTemplateId,
        eventId,
        regId,
        ac,
        name,
        comment,
        isClose,
        sortBy,
      });
      const uri = this.baseUrl + "setboxtemplate";
      //   console.log(uri);
      //   console.log(toSubmit);
      this.isAlertVisible = false;
      this.isWarningAlertVisible = false;
      this.sendpost(uri, toSubmit, 1);

      //   this.getboxTemplates(this.selectedEvent);
    },
    addTemplate() {
      this.newDialog = true;
      this.templateName = "";
      this.templateComment = "";
    },
    editTemplate(item) {
      //   console.log("editTemplate", item);
      this.selectedItem = item;
      this.templateName = item.Name;
      this.templateComment = item.CommentTemplate;
      this.editDialog = true;
      //   this.isEdit = true;
    },

    newBoxTemplate() {
      // console.log(regId);
      this.newDialog = false;
      var regId = this.regId;
      var ac = this.ac;
      var eventId = this.box.EventId;
      var name = this.templateName;
      var comment = this.templateComment;
      var isClose = this.isTemplateClose;
      //   var regId = regId;
      //   var roleId = roleId;
      var toSubmit = JSON.stringify({
        ac,
        eventId,
        regId,
        name,
        comment,
        isClose,
      });
      const uri = this.baseUrl + "newboxtemplate";
      //   console.log(uri);
      //   console.log(toSubmit);
      this.isAlertVisible = false;
      this.isWarningAlertVisible = false;
      this.sendpost(uri, toSubmit, 1);
      this.newDialog = false;
      //   this.getboxTemplates(this.selectedEvent);
    },

    getboxTemplates(boxid) {
      this.isAlertVisible = false;
      this.isWarningAlertVisible = false;
      var eventId = boxid;
      //   console.log("eventId", eventId);
      axios
        .get(this.baseUrl + "geteventcommenttemplates/" + eventId)
        .then((response) => {
          // JSON responses are automatically parsed.
          this.boxTemplates = response.data;
          this.loading = false;
          this.isTemplateClose = this.boxTemplates[0].IsCloseText;
          this.isTemplateOpen = !this.isTemplateClose;
          //   console.log("boxTemplates",this.boxTemplates)
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },
    setRegId(id) {
      // console.log("id", id);
      this.addregId = id;
      this.addUserEnabled = true;
    },

    sendpost(uri, toSubmit, type) {
      const axiosConfig = {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
        },
      };
      axios
        .post(uri, toSubmit, axiosConfig)
        .then((response) => {
          // console.log(response.data);
          if (type === 0) {
            this.statusResult = response.data.Result;
            this.statusResultMsg = response.data.ResultMsg;
          } else {
            this.statusResult = response.data[0].Result;
            this.statusResultMsg = response.data[0].ResultMsg;
          }
          this.setAlert(this.statusResult);
          //   this.getboxTemplates(eventId);
          //   if (this.statusResult === 1) {
          //       getstatus();
          //   }
        })
        .catch((e) => {
          this.errors.push(e);
          this.statusResult = 0;
          this.statusResultMsg = "Something went wrong!";
          this.setAlert(this.statusResult);
        });
    },
    setAlert(statusResult) {
      if (statusResult === 1) {
        this.isAlertVisible = true;
        this.isWarningAlertVisible = false;
      }
      if (statusResult === 0) {
        this.isWarningAlertVisible = true;
        this.isAlertVisible = false;
      }
    },
  },
  components: {
    // copybutton
  },
};
</script>